<template>
  <SysDialog v-model="dialog_ativo" ocultar-acoes :largura="450">
    <template #ativador>
      <v-btn style="background: rgba(90, 90, 90, .5)" dark @click="dialog_ativo = !dialog_ativo">
        <v-icon left>mdi-alert</v-icon>
        ok, exportar
      </v-btn>
    </template>

    <template #titulo.texto>
      <div>
        <p class="ma-0">Cambos obrigatórios</p>
        <p class="ma-0 mt-n2 font-12 font-weight-regular text-gray-900">Verifique se você informou todos os campos obrigatórios</p>
      </div>
    </template>

    <ul class="mt-n2">
      <li>Filial</li>
      <li>Comprador</li>
      <li>Fornecedor</li>
      <li>Condição de Pagamento</li>
      <li>Data de Entrega</li>
      <li>Data de Faturamento</li>
      <li>Qt. do Lote - para os produtos controlados por lote</li>
      <li>Tipo do Lote - para os produtos controlados por lote</li>
    </ul>
  </SysDialog>
</template>

<script setup>
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";
import {ref} from "vue";

const dialog_ativo = ref(false);
</script>
